import React from "react";
import { Stack } from "office-ui-fabric-react/lib/Stack";
import {
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode,
  Selection,
} from "office-ui-fabric-react/lib/DetailsList";

import { listS } from "../../../common/styles/list.styles";
import { operatorsColumns } from "../../data/operators-columns";
import { useTranslation } from 'react-i18next';

export interface OperatorsListProps {
  selection: Selection;
  items: Array<any>;
  handleInvoke: any;
}

const OperatorsList: React.FC<OperatorsListProps> = ({
  items,
  selection,
  handleInvoke,
}) => {
  const { t } = useTranslation('admin');
  return (
    <Stack>
      <DetailsList
        items={items}
        columns={operatorsColumns(t)}
        styles={listS}
        setKey="items"
        selection={selection}
        layoutMode={DetailsListLayoutMode.justified}
        selectionPreservedOnEmptyClick={true}
        selectionMode={SelectionMode.single}
        onItemInvoked={handleInvoke}
        usePageCache={true}
      />
    </Stack>
  );
};
export default OperatorsList;
